import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { projectConfigApi } from '../../../lib/project-config-api.js';
import { useCurrentProject } from '../../../lib/use-project.js';

// #112 (A6): Schalter fuer die Quell-ID (`source_ref`) — die fachliche ID aus der Importdatei
// (`WMI_09`), die im Katalog und in der Testplan-Auswahl neben der TestFlow-ID steht. Wer ohne
// Quelldateien arbeitet, blendet sie hier aus; Vorgabe ist eingeblendet.
//
// Aufbau woertlich nach gamification-panel.tsx: ein einzelner Schalter, kein Speichern-Knopf,
// sofortiger PATCH bei jeder Aenderung — sonst laufen UI-Zustand und Server auseinander.
// Bewusst KEIN Bedienelement fuer den Wert selbst: die Quell-ID ist ein reiner Importwert und
// nur lesbar, Korrekturweg ist der Neuimport (anforderung.md A6).
export function SourceRefPanel() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { project, isLoading: projectLoading } = useCurrentProject();
  const projectId = project?.project_id;

  const query = useQuery({
    queryKey: ['project-settings', projectId],
    queryFn: () => projectConfigApi.getSettings(projectId ?? ''),
    enabled: Boolean(projectId),
  });

  const patch = useMutation({
    mutationFn: (show_source_ref: boolean) =>
      projectConfigApi.patchSettings(projectId ?? '', { show_source_ref }),
    meta: { successToast: 'feedback.saved' },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['project-settings', projectId] });
    },
  });

  if (projectLoading) {
    return <div className="p-6 text-text-muted">{t('common.loading')}</div>;
  }
  if (!project || !projectId) {
    return <div className="p-6 text-text-muted">{t('catalog.noProject')}</div>;
  }

  return (
    <div className="space-y-4 p-6">
      <h2 className="text-lg font-bold text-text-primary">{t('admin.sourceRef.navLabel')}</h2>
      <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
        <label className="flex items-center gap-3 text-sm text-text-body">
          <input
            type="checkbox"
            checked={query.data?.show_source_ref ?? true}
            disabled={query.isLoading || patch.isPending}
            onChange={(e) => patch.mutate(e.target.checked)}
          />
          <span>{t('admin.sourceRef.enabledLabel')}</span>
        </label>
        <p className="mt-2 text-[11px] text-text-muted">{t('admin.sourceRef.hint')}</p>
      </section>
    </div>
  );
}
